<template>
  <div @click="closeEditMode()" class="out-scroll-wrp">
    <div class="linkDio-tit" v-if="title.length > 0">
      {{ title }}
    </div>
    <div v-else>
      <p class="subtitle">{{ subtitle }}</p>
      <p class="minititle">{{ minititle }}</p>
    </div>

    <br>

    <div v-if="!loading && tableData.length > 0" class="table-outline table-tree">
      <div class="table-head clear">
        <div class="table-head-left"></div>
        <div class="table-head-week">
          <h3>{{ dayInString() }}</h3>
          <h4>{{ getDateInString() }}</h4>
        </div>
        <div class="table-head-week">
          <h3>{{ dayInString(1) }}</h3>
          <h4>{{ getDateInString(1) }}</h4>
        </div>
        <div class="table-head-week">
          <h3>{{ dayInString(2) }}</h3>
          <h4>{{ getDateInString(2) }}</h4>
        </div>
        <div class="table-head-week">
          <h3>{{ dayInString(3) }}</h3>
          <h4>{{ getDateInString(3) }}</h4>
        </div>
        <div class="table-head-week">
          <h3>{{ dayInString(4) }}</h3>
          <h4>{{ getDateInString(4) }}</h4>
        </div>
        <div class="table-head-week">
          <h3>{{ dayInString(5) }}</h3>
          <h4>{{ getDateInString(5) }}</h4>
        </div>
        <div class="table-head-week">
          <h3>{{ dayInString(6) }}</h3>
          <h4>{{ getDateInString(6) }}</h4>
        </div>
        <div class="table-head-week">
          <h3>Total</h3>
          <h4></h4>
        </div>
      </div>

      <div class="table-oldest" v-for="(item, index) in tableData" :key="index">
        <div class="table-body-line clear">
          <div class="table-line-left pad-lft-20 font16 pad-rgt-40 1" @click="item.shrink = !item.shrink"
            :class="{ 'small': item.left === 'Forecast Revenue' }">
            {{ item.left }} <br />
            <span class="small" v-if="item.left === 'Forecast Revenue'">(Default)</span>
            <div v-if="item.left === 'Total'" class="arw" :class="{ 'up': item.shrink }"></div>
          </div>
          <div class="table-line-data not-allowed" :id="`headerLine-${i}`"
            :class="(item[`${generateDayName(weekStart, i)}`] >= 0 || item.left === 'Forecast Revenue') ? item.color : 'pink'"
            v-for="(num, i) in 7" :key="`headerLine-${i}`">
            {{ item.left === 'Total' ? $box.formatMoney3(item[`${generateDayName(weekStart, i)}`]) :
              $box.formatMoney4(item[`${generateDayName(weekStart, i)}`]) }}
          </div>
          <div class="table-line-data not-allowed green">
            {{ item.left === 'Total' ? $box.formatMoney3(item.total.toFixed(2)) :
              $box.formatMoney4(item.total.toFixed(2)) }}
          </div>
        </div>
        <transition name="el-zoom-in-top">
          <div v-if="item.shrink">
            <div class="table-second" v-for="(son, son_index) in item.son" :key="son_index">
              <div class="table-body-line clear">
                <div class="table-line-left pad-lft-40 font16 pad-rgt-40" @click="son.shrink = !son.shrink"
                  :class="{ 'hideArrow': son.hideArrow }">
                  {{ son.left }} <div class="arw" :class="{ 'up': son.shrink }"></div>
                </div>
                <div class="table-line-data" :class="son.color"
                  :style="{ 'cursor': !son.ofDoshii && son.hideArrow ? 'pointer' : 'not-allowed' }"
                  v-for="(num, i) in 7" :key="`tableLineData-${i}`" :id="`son-tableLine-${i}`">
                  <span v-if="!son[`${generateDayEditName(weekStart, i)}`]"
                    @click.stop="closeEditMode(), son[`${generateDayEditName(weekStart, i)}`] = son.hideArrow ? (son.ofDoshii ? false : true) : false, son.hideArrow ? focus(`${generateDayName(weekStart, i)}${index}${son_index}`) : ''">
                    {{ son.hideArrow ? $box.formatMoneyLabour(son[`${generateDayName(weekStart, i)}`]) :
                      $box.formatMoney3(son[`${generateDayName(weekStart, i)}`]) }}
                  </span>

                  <el-input
                    @input="son[`${generateDayName(weekStart, i)}`] = removeSymbols(son[`${generateDayName(weekStart, i)}`])"
                    :ref="`${generateDayName(weekStart, i)}${index}${son_index}`"
                    v-if="son[`${generateDayEditName(weekStart, i)}`] && !son.ofDoshii && son.hideArrow"
                    v-model="son[`${generateDayName(weekStart, i)}`]"
                    :autofocus="true"
                    :trigger-on-focus="true"
                    @blur="son[`${generateDayEditName(weekStart, i)}`] = false" maxlength="10" />
                </div>
                <div class="table-line-data not-allowed green">
                  <span>{{ son.total ? $box.formatMoneyLabour(son.total.toFixed(2)) : '$0.00' }}</span>
                </div>
              </div>
              <transition name="el-zoom-in-top">
                <div v-if="son.shrink && son.son.length > 0">
                  <div class="table-youngest" v-for="(grandson, grandson_index) in filterSonParent(son.son)"
                    :key="grandson_index" :id="`grandson-tableLine-${grandson_index}`">

                    <div class="table-body-line clear">
                      <div v-if="filterSonChild(grandson.left, son.son)" class="table-line-left pad-lft-60 font18"
                        @click="grandson.shrink = !grandson.shrink">
                        {{ grandson.left }} <div class="arw" :class="{ 'up': grandson.shrink }"></div>
                      </div>
                      <div v-else class="table-line-left pad-lft-60 font18">
                        {{ grandson.left }}
                      </div>

                      <div class="table-line-data" @click.stop :class="grandson.color" v-for="(num, i) in 7" :key="i">
                        <!-- <div class="position-absolute cursor-pointer clear-value" :class="{'d-none' : grandson[`${generateDayName(weekStart, i)}`] == undefined}" @click="grandson[`${generateDayName(weekStart, i)}`] = ''">
                          Clear
                        </div> -->
                        <span :style="{ 'cursor': grandson.ofDoshii ? 'not-allowed' : 'pointer' }"
                          v-if="!grandson[`${generateDayEditName(weekStart, i)}`]"
                          @click.stop="closeEditMode(), grandson[`${generateDayEditName(weekStart, i)}`] = grandson.ofDoshii ? false : true, focus(`${generateDayName(weekStart, i)}${index}${grandson_index}`)">
                          {{ calculateDisplayValue(grandson, generateDayName(weekStart, i)) }}
                        </span>
                        <el-input
                          @input="grandson[`${generateDayName(weekStart, i)}`] = (grandson.withDollar || grandson.revenueType === 3) ? removeSymbols(grandson[`${generateDayName(weekStart, i)}`], grandson.left) : grandson[`${generateDayName(weekStart, i)}`].replace(/[^\d]/g, '')"
                          :ref="`${generateDayName(weekStart, i)}${index}${grandson_index}`"
                          v-if="grandson[`${generateDayEditName(weekStart, i)}`] && !grandson.ofDoshii"
                          v-model="grandson[`${generateDayName(weekStart, i)}`]"
                          :autofocus="true"
                          :trigger-on-focus="true"
                          @blur="grandson[`${generateDayEditName(weekStart, i)}`] = false, calculate()"
                          maxlength="10" />
                          
                      </div>

                      <div class="table-line-data green">
                        <span style="cursor: not-allowed;">
                          {{ grandson.total ? $box.formatMoney5(grandson.total) : '$0.00' }}
                        </span>
                      </div>
                    </div>

                    <!-- Add child son -->
                    <transition name="el-zoom-in-top">
                      <div v-if="grandson.shrink && filterSonChild(grandson.left, son.son)">
                        <div class="table-youngest"
                          v-for="(grandchild, grandchild_index) in filterSonChild(grandson.left, son.son)"
                          :key="grandchild_index">
                          <div class="table-body-line clear">
                            <div class="table-line-left pad-lft-80 font18">
                              {{ grandchild.left }}
                            </div>

                            <div class="table-line-data" @click.stop :class="grandchild.color" v-for="(num, i) in 7"
                              :key="i" :id="`grandchild-tableLine-${i}`">
                              <span :style="{ 'cursor': grandchild.ofDoshii ? 'not-allowed' : 'pointer' }"
                                v-if="!grandchild[`${generateDayEditName(weekStart, i)}`]"
                                @click.stop="closeEditMode(), grandchild[`${generateDayEditName(weekStart, i)}`] = grandchild.ofDoshii ? false : true, focus(`grandchild${generateDayName(weekStart, i)}${index}${grandchild_index}`)">
                                {{ calculateDisplayValue(grandchild, generateDayName(weekStart, i), true) }}
                              </span>
                              <el-input
                                @input="grandchild[`${generateDayName(weekStart, i)}`] = (grandchild.withDollar || grandchild.revenueType === 3) ? removeSymbols(grandchild[`${generateDayName(weekStart, i)}`], grandchild.left) : grandchild[`${generateDayName(weekStart, i)}`].replace(/[^\d]/g, '')"
                                :ref="`grandchild${generateDayName(weekStart, i)}${index}${grandchild_index}`"
                                v-if="grandchild[`${generateDayEditName(weekStart, i)}`] && !grandchild.ofDoshii"
                                v-model="grandchild[`${generateDayName(weekStart, i)}`]"
                                :autofocus="true"
                                :trigger-on-focus="true"
                                @blur="grandchild[`${generateDayEditName(weekStart, i)}`] = false, calculate()"
                                maxlength="10" />
                            </div>
                            <div class="table-line-data green">
                              <span style="cursor: not-allowed;">
                                {{ grandchild.total ? $box.formatMoney3(grandchild.total.toFixed(2)) : '$0.00' }}
                              </span>
                            </div>

                          </div>
                        </div>
                      </div>
                    </transition>

                  </div>
                </div>
              </transition>
            </div>
          </div>
        </transition>
      </div>

    </div>
    <div v-if="loading" class="not-yet">
      <i class="el-icon-loading"></i>
    </div>
    <div v-if="!loading && tableData.length === 0" class="not-yet">
      -
    </div>
    <div class="text-warn pad-x-2rem">{{ text }}</div>
    <div class="table-btns clear d-flex justify-content-center">
      <el-button class="cancel" @click.stop="cancalOperate">Cancel</el-button>
      <el-button class="confirm" @click.stop="confirmOperate">Confirm <i v-if="requesting" class="el-icon-loading"
          style="font-size:20px"></i></el-button>
    </div>
  </div>
</template>

<script>
import utils from '@/utils/utils'
export default {
  name: 'treeTable',
  props: {
    hasLabour: {
      type: Boolean,
      default: true
    },
    weekStart: {
      type: Number,
      default: 1
    },
    currentWeek: {
      type: Array,
      default: []
    },
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    minititle: {
      type: String,
      default: ''
    },
    list: {
      type: Array,
      default: []
    },
    loading: {
      type: Boolean,
      default: false
    },
    requesting: {
      type: Boolean,
      default: false
    },
    initUpdate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      first: 0,
      tableData: [
        /*{
            left: 'Total',
            mon: 7887,
            tues: -98,
            wed: 988,
            thu: 789,
            fri: 246,
            sat: 78,
            sun: 24,
            shrink: false,
            color: 'green',
            son: [
                {
                    left: 'Revenue',
                    mon: 7887,
                    tues: 98,
                    wed: 988,
                    thu: 789,
                    fri: 246,
                    sat: 78,
                    sun: 24,
                    shrink: false,
                    color: 'green',
                    son:[
                        {
                            left: 'Doshii Revenue',
                            mon: 7887,
                            tues: 98,
                            wed: 988,
                            thu: 789,
                            fri: 246,
                            sat: 78,
                            sun: 24,

                            editmon: false,
                            edittues: false,
                            editwed: false,
                            editthu: false,
                            editfri: false,
                            editsat: false,
                            editsun: false,

                            withDollar: true,
                            color: 'green',
                        }
                    ]
                },
                {
                    left: 'Expenses',
                    mon: 7887,
                    tues: 98,
                    wed: 988,
                    thu: 789,
                    fri: 246,
                    sat: 78,
                    sun: 24,
                    shrink: false,
                    color: 'pink',
                    son: [
                        {
                            left: 'Open Table Bookings',
                            mon: 7887,
                            tues: 98,
                            wed: 988,
                            thu: 789,
                            fri: 246,
                            sat: 78,
                            sun: 24,

                            editmon: false,
                            edittues: false,
                            editwed: false,
                            editthu: false,
                            editfri: false,
                            editsat: false,
                            editsun: false,

                            withDollar: false,
                            color: ''
                        }
                    ]
                }
            ]
        }*/
      ],
    }
  },
  methods: {
    filterSonParent(son) {
      const result = son.filter(item => item.parentRevenue == null);
      return result;
    },
    filterSonChild(incomeName, son) {
      const result = son.filter(item => item.parentRevenue == incomeName);
      return result.length > 0 ? result : null;
    },
    confirmOperate() {
      if (this.loading)
        return
      // this.loading = true
      // 把数据整理一下
      let params = []
      this.tableData.forEach(item => {
        if (item.left === 'Total') {
          item.son.forEach(son => {
            if (son.hideArrow) {
              params.push({
                "fri": son.fri === null || son.fri === '' ? null : Number(son.fri),
                "id": son.id,
                "incomeId": son.incomeId,
                "incomeType": son.incomeType,
                "mon": son.mon === null || son.mon === '' ? null : Number(son.mon),
                "monDateTime": son.monDateTime,
                "revenueType": son.revenueType,
                "sat": son.sat === null || son.sat === '' ? null : Number(son.sat),
                "sun": son.sun === null || son.sun === '' ? null : Number(son.sun),
                "sunDateTime": son.sunDateTime,
                "thu": son.thu === null || son.thu === '' ? null : Number(son.thu),
                "tue": son.tues === null || son.tues === '' ? null : Number(son.tues),
                "wed": son.wed === null || son.wed === '' ? null : Number(son.wed),
                "expensesType": son.expensesType
              })
            } else if (son.son) {
              son.son.forEach(grandson => {
                params.push({
                  "fri": grandson.fri === '' ? null : Number(grandson.fri),
                  "id": grandson.id,
                  "incomeId": grandson.incomeId,
                  "incomeType": grandson.incomeType,
                  "mon": grandson.mon === '' ? null : Number(grandson.mon),
                  "monDateTime": grandson.monDateTime,
                  "revenueType": grandson.revenueType,
                  "sat": grandson.sat === '' ? null : Number(grandson.sat),
                  "sun": grandson.sun === '' ? null : Number(grandson.sun),
                  "sunDateTime": grandson.sunDateTime,
                  "thu": grandson.thu === '' ? null : Number(grandson.thu),
                  "tue": grandson.tues === '' ? null : Number(grandson.tues),
                  "wed": grandson.wed === '' ? null : Number(grandson.wed),
                  "expensesType": grandson.expensesType
                })
              })
            }
          })
        }
      })

      if (this.initUpdate) {
        this.$emit('confirmInitUpdate', params)
      } else {
        this.$emit('confirm', params)
      }

      this.first = 0
    },
    cancalOperate() {
      if (this.loading)
        return
      this.tableData = []
      this.$emit('cancel')
      this.first = 0
    },
    closeEditMode() {
      this.tableData.forEach(item => {
        if (item.son)
          item.son.forEach((son) => {
            son.editmon = false
            son.edittues = false
            son.editwed = false
            son.editthu = false
            son.editfri = false
            son.editsat = false
            son.editsun = false
            if (son.son)
              son.son.forEach(grandson => {
                grandson.editmon = false
                grandson.edittues = false
                grandson.editwed = false
                grandson.editthu = false
                grandson.editfri = false
                grandson.editsat = false
                grandson.editsun = false
              })
          })
      })
    },
    calculate() {
      let hasTips = false
      this.tableData.forEach(item => {
        if (item.son) {  // main
          let temp_item_mon = 0
          let temp_item_tues = 0
          let temp_item_wed = 0
          let temp_item_thu = 0
          let temp_item_fri = 0
          let temp_item_sat = 0
          let temp_item_sun = 0

          let null_number_mon = 0
          let null_number_tues = 0
          let null_number_wed = 0
          let null_number_thu = 0
          let null_number_fri = 0
          let null_number_sat = 0
          let null_number_sun = 0
          item.son.forEach((son) => {
            if (son.hideArrow)
              return
            if (son.son) {
              let son_temp_mon = 0
              let son_temp_tues = 0
              let son_temp_wed = 0
              let son_temp_thu = 0
              let son_temp_fri = 0
              let son_temp_sat = 0
              let son_temp_sun = 0
              let son_total = 0

              let grand_null_number_mon = 0
              let grand_null_number_tues = 0
              let grand_null_number_wed = 0
              let grand_null_number_thu = 0
              let grand_null_number_fri = 0
              let grand_null_number_sat = 0
              let grand_null_number_sun = 0

              son.son.forEach((grandson, index) => {
                if (grandson.parentRevenue == null) {
                  if (grandson.left === 'Gratuity' || grandson.left === 'Tips' || grandson.left === 'Mr Yum' || grandson.left === 'Service Charge') {
                    hasTips = true
                    if (grandson.left == 'Mr Yum') {
                      grandson.left = 'Me&U'
                    }

                    return
                  }
                  if (grandson.mon === null || grandson.mon === '') {
                    grand_null_number_mon++
                  }
                  if (grandson.tues === null || grandson.tues === '') {
                    grand_null_number_tues++
                  }
                  if (grandson.wed === null || grandson.wed === '') {
                    grand_null_number_wed++
                  }
                  if (grandson.thu === null || grandson.thu === '') {
                    grand_null_number_thu++
                  }
                  if (grandson.fri === null || grandson.fri === '') {
                    grand_null_number_fri++
                  }
                  if (grandson.sat === null || grandson.sat === '') {
                    grand_null_number_sat++
                  }
                  if (grandson.sun === null || grandson.sun === '') {
                    grand_null_number_sun++
                  }
                  // onsole.log(son_temp_fri)
                  // revenueType是1，金额 = 【（incomeCommission * 对应的金额）保留两位小数四舍五入】
                  if (grandson.mon && typeof (grandson.mon) === 'string')
                    grandson.mon = Number(grandson.mon)
                  if (grandson.tues && typeof (grandson.tues) === 'string')
                    grandson.tues = Number(grandson.tues)
                  if (grandson.wed && typeof (grandson.wed) === 'string')
                    grandson.wed = Number(grandson.wed)
                  if (grandson.thu && typeof (grandson.thu) === 'string')
                    grandson.thu = Number(grandson.thu)
                  if (grandson.fri && typeof (grandson.fri) === 'string')
                    grandson.fri = Number(grandson.fri)
                  if (grandson.sat && typeof (grandson.sat) === 'string')
                    grandson.sat = Number(grandson.sat)
                  if (grandson.sun && typeof (grandson.sun) === 'string')
                    grandson.sun = Number(grandson.sun)
                  if (grandson.revenueType === 1) {
                    son_temp_mon = grandson.mon ? (Number((grandson.mon * grandson.incomeCommission).toFixed(2))) + son_temp_mon : son_temp_mon
                    son_temp_tues = grandson.tues ? (Number((grandson.tues * grandson.incomeCommission).toFixed(2))) + son_temp_tues : son_temp_tues
                    son_temp_wed = grandson.wed ? (Number((grandson.wed * grandson.incomeCommission).toFixed(2))) + son_temp_wed : son_temp_wed
                    son_temp_thu = grandson.thu ? (Number((grandson.thu * grandson.incomeCommission).toFixed(2))) + son_temp_thu : son_temp_thu
                    son_temp_fri = grandson.fri ? (Number((grandson.fri * grandson.incomeCommission).toFixed(2))) + son_temp_fri : son_temp_fri
                    son_temp_sat = grandson.sat ? (Number((grandson.sat * grandson.incomeCommission).toFixed(2))) + son_temp_sat : son_temp_sat
                    son_temp_sun = grandson.sun ? (Number((grandson.sun * grandson.incomeCommission).toFixed(2))) + son_temp_sun : son_temp_sun
                    // console.log(son_temp_fri)
                  } else if (grandson.revenueType === 2) {
                    // revenueType是2，金额 =  对应的金额 -【（incomeCommission * 对应的金额）保留两位小数四舍五入】
                    son_temp_mon = grandson.mon ? (grandson.mon - Number((grandson.mon * grandson.incomeCommission).toFixed(2))) + son_temp_mon : son_temp_mon
                    son_temp_tues = grandson.tues ? (grandson.tues - Number((grandson.tues * grandson.incomeCommission).toFixed(2))) + son_temp_tues : son_temp_tues
                    son_temp_wed = grandson.wed ? (grandson.wed - Number((grandson.wed * grandson.incomeCommission).toFixed(2))) + son_temp_wed : son_temp_wed
                    son_temp_thu = grandson.thu ? (grandson.thu - Number((grandson.thu * grandson.incomeCommission).toFixed(2))) + son_temp_thu : son_temp_thu

                    son_temp_fri = grandson.fri ? (grandson.fri - Number((grandson.fri * grandson.incomeCommission).toFixed(2))) + son_temp_fri : son_temp_fri
                    son_temp_sat = grandson.sat ? (grandson.sat - Number((grandson.sat * grandson.incomeCommission).toFixed(2))) + son_temp_sat : son_temp_sat
                    son_temp_sun = grandson.sun ? (grandson.sun - Number((grandson.sun * grandson.incomeCommission).toFixed(2))) + son_temp_sun : son_temp_sun

                    //console.log(son_temp_fri)
                  } else if (grandson.revenueType === 3) {
                    son_temp_mon = grandson.mon ? (grandson.mon) + son_temp_mon : son_temp_mon
                    son_temp_tues = grandson.tues ? (grandson.tues) + son_temp_tues : son_temp_tues
                    son_temp_wed = grandson.wed ? (grandson.wed) + son_temp_wed : son_temp_wed
                    son_temp_thu = grandson.thu ? (grandson.thu) + son_temp_thu : son_temp_thu

                    son_temp_fri = grandson.fri ? (grandson.fri) + son_temp_fri : son_temp_fri
                    son_temp_sat = grandson.sat ? (grandson.sat) + son_temp_sat : son_temp_sat
                    son_temp_sun = grandson.sun ? (grandson.sun) + son_temp_sun : son_temp_sun

                  }
                  son_temp_mon = typeof (son_temp_mon) === 'string' ? Number((Number(son_temp_mon)).toFixed(2)) : Number(son_temp_mon.toFixed(2))
                  son_temp_tues = typeof (son_temp_tues) === 'string' ? Number((Number(son_temp_tues)).toFixed(2)) : Number(son_temp_tues.toFixed(2))
                  son_temp_wed = typeof (son_temp_wed) === 'string' ? Number((Number(son_temp_wed)).toFixed(2)) : Number(son_temp_wed.toFixed(2))
                  son_temp_thu = typeof (son_temp_thu) === 'string' ? Number((Number(son_temp_thu)).toFixed(2)) : Number(son_temp_thu.toFixed(2))
                  son_temp_fri = typeof (son_temp_fri) === 'string' ? Number((Number(son_temp_fri)).toFixed(2)) : Number(son_temp_fri.toFixed(2))
                  son_temp_sat = typeof (son_temp_sat) === 'string' ? Number((Number(son_temp_sat)).toFixed(2)) : Number(son_temp_sat.toFixed(2))
                  son_temp_sun = typeof (son_temp_sun) === 'string' ? Number((Number(son_temp_sun)).toFixed(2)) : Number(son_temp_sun.toFixed(2))

                }

                grandson.total = parseFloat(grandson.mon ? grandson.mon : 0) + parseFloat(grandson.tues ? grandson.tues : 0) + parseFloat(grandson.wed ? grandson.wed : 0) + parseFloat(grandson.thu ? grandson.thu : 0) + parseFloat(grandson.fri ? grandson.fri : 0) + parseFloat(grandson.sat ? grandson.sat : 0) + parseFloat(grandson.sun ? grandson.sun : 0)
              })
              /* 您需要认真阅读该注释以便理解下列代码
              需求：如果表格最底层的数据，每个对象的同个键值都为null（也就是整一列都是null）, 它的total就要为null显示
              所以思路是每次都要去计算null的数量
              那么问题来了，expensesType 有多种类型，1是收入，收入里面有个Tips, 这个是不纳入total的计算的
              判断规则就是判断接口返回的标题是不是叫Tips，至多只有一个Tips
              所以在判断null个数的时候，如果expensesType = 1 且有小费，null的数量 = 子数组长度 - 1
              如果expensesType = 1 且没有小费，null的数量 = 子数组长度
              如果expensesType !== 1，null的数量 = 子数组长度 */
              if ((((son.son.length === grand_null_number_mon && !hasTips) || (son.son.length - 1 === grand_null_number_mon && hasTips)) && son.expensesType === 1) ||
                (son.son.length === grand_null_number_mon) && son.expensesType !== 1)
                son.total_mon_null = true
              else
                son.total_mon_null = false
              if ((((son.son.length === grand_null_number_tues && !hasTips) || (son.son.length - 1 === grand_null_number_tues && hasTips)) && son.expensesType === 1) ||
                (son.son.length === grand_null_number_tues) && son.expensesType !== 1)
                son.total_tues_null = true
              else
                son.total_tues_null = false
              if ((((son.son.length === grand_null_number_wed && !hasTips) || (son.son.length - 1 === grand_null_number_wed && hasTips)) && son.expensesType === 1) ||
                (son.son.length === grand_null_number_wed) && son.expensesType !== 1)
                son.total_wed_null = true
              else
                son.total_wed_null = false
              if ((((son.son.length === grand_null_number_thu && !hasTips) || (son.son.length - 1 === grand_null_number_thu && hasTips)) && son.expensesType === 1) ||
                (son.son.length === grand_null_number_thu) && son.expensesType !== 1)
                son.total_thu_null = true
              else
                son.total_thu_null = false
              if ((((son.son.length === grand_null_number_fri && !hasTips) || (son.son.length - 1 === grand_null_number_fri && hasTips)) && son.expensesType === 1) ||
                (son.son.length === grand_null_number_fri) && son.expensesType !== 1)
                son.total_fri_null = true
              else
                son.total_fri_null = false
              if ((((son.son.length === grand_null_number_sat && !hasTips) || (son.son.length - 1 === grand_null_number_sat && hasTips)) && son.expensesType === 1) ||
                (son.son.length === grand_null_number_sat) && son.expensesType !== 1)
                son.total_sat_null = true
              else
                son.total_sat_null = false
              if ((((son.son.length === grand_null_number_sun && !hasTips) || (son.son.length - 1 === grand_null_number_sun && hasTips)) && son.expensesType === 1) ||
                (son.son.length === grand_null_number_sun) && son.expensesType !== 1)
                son.total_sun_null = true
              else
                son.total_sun_null = false
              // 如果expensesType是1，2，total计算数据是正数，是收入的费用
              if (son.expensesType === 1 || son.expensesType === 2) {
                son.mon = son_temp_mon ? son_temp_mon : (son.total_mon_null ? null : '0')
                son.tues = son_temp_tues ? son_temp_tues : (son.total_tues_null ? null : '0')
                son.wed = son_temp_wed ? son_temp_wed : (son.total_wed_null ? null : '0')
                son.thu = son_temp_thu ? son_temp_thu : (son.total_thu_null ? null : '0')
                son.fri = son_temp_fri ? son_temp_fri : (son.total_fri_null ? null : '0')
                son.sat = son_temp_sat ? son_temp_sat : (son.total_sat_null ? null : '0')
                son.sun = son_temp_sun ? son_temp_sun : (son.total_sun_null ? null : '0')
              }
              // 如果expensesType是3，total计算的数据是负数，是支出的费用
              else {
                if (son.expensesType === 4 && son.left === 'Labour') {
                  son.mon = son_temp_mon ? (son_temp_mon < 0 ? Math.abs(son_temp_mon) : `-${son_temp_mon}`) : (son.total_mon_null ? null : '0')
                  son.tues = son_temp_tues ? (son_temp_tues < 0 ? Math.abs(son_temp_tues) : `-${son_temp_tues}`) : (son.total_tues_null ? null : '0')
                  son.wed = son_temp_wed ? (son_temp_wed < 0 ? Math.abs(son_temp_wed) : `-${son_temp_wed}`) : (son.total_wed_null ? null : '0')
                  son.thu = son_temp_thu ? (son_temp_thu < 0 ? Math.abs(son_temp_thu) : `-${son_temp_thu}`) : (son.total_thu_null ? null : '0')
                  son.fri = son_temp_fri ? (son_temp_fri < 0 ? Math.abs(son_temp_fri) : `-${son_temp_fri}`) : (son.total_fri_null ? null : '0')
                  son.sat = son_temp_sat ? (son_temp_sat < 0 ? Math.abs(son_temp_sat) : `-${son_temp_sat}`) : (son.total_sat_null ? null : '0')
                  son.sun = son_temp_sun ? (son_temp_sun < 0 ? Math.abs(son_temp_sun) : `-${son_temp_sun}`) : (son.total_sun_null ? null : '0')
                } else {
                  son.mon = son_temp_mon ? (son_temp_mon < 0 ? son_temp_mon : `-${son_temp_mon}`) : (son.total_mon_null ? null : '0')
                  son.tues = son_temp_tues ? (son_temp_tues < 0 ? son_temp_tues : `-${son_temp_tues}`) : (son.total_tues_null ? null : '0')
                  son.wed = son_temp_wed ? (son_temp_wed < 0 ? son_temp_wed : `-${son_temp_wed}`) : (son.total_wed_null ? null : '0')
                  son.thu = son_temp_thu ? (son_temp_thu < 0 ? son_temp_thu : `-${son_temp_thu}`) : (son.total_thu_null ? null : '0')
                  son.fri = son_temp_fri ? (son_temp_fri < 0 ? son_temp_fri : `-${son_temp_fri}`) : (son.total_fri_null ? null : '0')
                  son.sat = son_temp_sat ? (son_temp_sat < 0 ? son_temp_sat : `-${son_temp_sat}`) : (son.total_sat_null ? null : '0')
                  son.sun = son_temp_sun ? (son_temp_sun < 0 ? son_temp_sun : `-${son_temp_sun}`) : (son.total_sun_null ? null : '0')
                }

              }

              if (son.mon && typeof (son.mon) === 'string')
                son.mon = Number(son.mon)
              if (son.tues && typeof (son.tues) === 'string')
                son.tues = Number(son.tues)
              if (son.wed && typeof (son.wed) === 'string')
                son.wed = Number(son.wed)
              if (son.thu && typeof (son.thu) === 'string')
                son.thu = Number(son.thu)
              if (son.fri && typeof (son.fri) === 'string')
                son.fri = Number(son.fri)
              if (son.sat && typeof (son.sat) === 'string')
                son.sat = Number(son.sat)
              if (son.sun && typeof (son.sun) === 'string')
                son.sun = Number(son.sun)

              son.total = parseFloat(son.mon ? son.mon : 0) + parseFloat(son.tues ? son.tues : 0) + parseFloat(son.wed ? son.wed : 0) + parseFloat(son.thu ? son.thu : 0) + parseFloat(son.fri ? son.fri : 0) + parseFloat(son.sat ? son.sat : 0) + parseFloat(son.sun ? son.sun : 0)

            }


            if (son.mon === null || son.mon === '')
              null_number_mon++
            if (son.tues === null || son.tues === '')
              null_number_tues++
            if (son.wed === null || son.wed === '')
              null_number_wed++
            if (son.thu === null || son.thu === '')
              null_number_thu++
            if (son.fri === null || son.fri === '')
              null_number_fri++
            if (son.sat === null || son.sat === '')
              null_number_sat++
            if (son.sun === null || son.sun === '')
              null_number_sun++


            if (son.expensesType !== 4 && son.left !== 'Labour') {
              temp_item_mon = son.mon ? Number((son.mon + temp_item_mon).toFixed(2)) : temp_item_mon
              temp_item_tues = son.tues ? Number((son.tues + temp_item_tues).toFixed(2)) : temp_item_tues
              temp_item_wed = son.wed ? Number((son.wed + temp_item_wed).toFixed(2)) : temp_item_wed
              temp_item_thu = son.thu ? Number((son.thu + temp_item_thu).toFixed(2)) : temp_item_thu
              temp_item_fri = son.fri ? Number((son.fri + temp_item_fri).toFixed(2)) : temp_item_fri
              temp_item_sat = son.sat ? Number((son.sat + temp_item_sat).toFixed(2)) : temp_item_sat
              temp_item_sun = son.sun ? Number((son.sun + temp_item_sun).toFixed(2)) : temp_item_sun
            }



          })
          if ((item.son.length === null_number_mon && !this.hasLabour) || (item.son.length === null_number_mon + 1 && this.hasLabour))
            item.mon_null = true
          else
            item.mon_null = false
          if ((item.son.length === null_number_tues && !this.hasLabour) || (item.son.length === null_number_tues + 1 && this.hasLabour))
            item.tues_null = true
          else
            item.tues_null = false
          if ((item.son.length === null_number_wed && !this.hasLabour) || (item.son.length === null_number_wed + 1 && this.hasLabour))
            item.wed_null = true
          else
            item.wed_null = false
          if ((item.son.length === null_number_thu && !this.hasLabour) || (item.son.length === null_number_thu + 1 && this.hasLabour))
            item.thu_null = true
          else
            item.thu_null = false
          if ((item.son.length === null_number_fri && !this.hasLabour) || (item.son.length === null_number_fri + 1 && this.hasLabour))
            item.fri_null = true
          else
            item.fri_null = false
          if ((item.son.length === null_number_sat && !this.hasLabour) || (item.son.length === null_number_sat + 1 && this.hasLabour))
            item.sat_null = true
          else
            item.sat_null = false
          if ((item.son.length === null_number_sun && !this.hasLabour) || (item.son.length === null_number_sun + 1 && this.hasLabour))
            item.sun_null = true
          else
            item.sun_null = false

          item.mon = temp_item_mon ? temp_item_mon : (item.mon_null ? null : 0)
          item.tues = temp_item_tues ? temp_item_tues : (item.tues_null ? null : 0)
          item.wed = temp_item_wed ? temp_item_wed : (item.wed_null ? null : 0)
          item.thu = temp_item_thu ? temp_item_thu : (item.thu_null ? null : 0)
          item.fri = temp_item_fri ? temp_item_fri : (item.fri_null ? null : 0)
          item.sat = temp_item_sat ? temp_item_sat : (item.sat_null ? null : 0)
          item.sun = temp_item_sun ? temp_item_sun : (item.sun_null ? null : 0)

          item.total = parseFloat(item.mon ? item.mon : 0) + parseFloat(item.tues ? item.tues : 0) + parseFloat(item.wed ? item.wed : 0) + parseFloat(item.thu ? item.thu : 0) + parseFloat(item.fri ? item.fri : 0) + parseFloat(item.sat ? item.sat : 0) + parseFloat(item.sun ? item.sun : 0)
        }
      })

    },
    focus(type) {
      this.$nextTick(() => {
        if (this.$refs[type] && this.$refs[type][0]) {
          this.$refs[type][0].focus()
          if (typeof(this.$refs[type][0].value) == 'object') {
            this.$refs[type][0].value = 0
          }
        } else {
          
        }
        
      })
    },

    dayInString(pos = 0) {
      const day = ['', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
      var dayStart = this.weekStart + pos

      if (dayStart > 7) {
        dayStart = dayStart - 7
      }

      return day[dayStart]
    },

    getDateInString(pos = 0) {
      var day = this.dayInString(pos)
      var dtString = utils.getTimeByDay(day.toLowerCase(), this.currentWeek)

      return dtString
    },

    removeSymbols(val, name = null) {
  
      if (name == 'Labour') {
        if (val.length > 1) {
          let numericString = parseFloat(val);
          if (!isNaN(numericString)) {
            // val = numericString.toString();
            var data = val.replace(/[^\d.-]/g, '').replace(/^\./g, '').replace(/\.{2,}/g, '').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(-?)(\d+)\.(\d\d).*$/, '$1$2.$3');
            return data
          } else {
            return '';
          }
        } else {
          return val;
        }
      } else {
        var data = val.replace(/[^\d.]/g, '').replace(/^\./g, '').replace(/\.{2,}/g, '').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
        return data
      }
    },

    generateDayName(weekStart, day) {
      const dayName = ['', 'mon', 'tues', 'wed', 'thu', 'fri', 'sat', 'sun']
      var start = weekStart + day
      if (start > 7) {
        start = start - 7
      }
      var name = dayName[start]
      return name

    },

    generateDayEditName(weekStart, day) {
      const dayName = ['', 'editmon', 'edittues', 'editwed', 'editthu', 'editfri', 'editsat', 'editsun']
      var start = weekStart + day
      if (start > 7) {
        start = start - 7
      }
      var name = dayName[start]
      return name

    },

    calculateDisplayValue(item, dayName, isGrandchild = false) {
      const value = item[dayName]
      const formatMoney = isGrandchild ? this.$box.formatMoney3 : this.$box.formatMoney6

      // Handle non-dollar case
      if (!item.withDollar) {
        return item.revenueType === 3 && value ? `-$${value}` : value
      }

      // Handle expenses type 3
      if (item.expensesType === 3) {
        return formatMoney(value)
      }

      // Handle revenue calculations
      if (item.revenueType === 1) {
        return value ? formatMoney(value * item.incomeCommission) : value
      }

      if (item.revenueType === 2) {
        return value ? formatMoney((value - value * item.incomeCommission).toFixed(2)) : value
      }

      return value
    },

  },
  watch: {
    'list': {
      deep: true,
      handler: function (val) {
        this.tableData = val

        if (val.length > 0 && this.first === 0) {
          this.calculate()
          if (this.initUpdate) {
            this.confirmOperate();
          }
          this.first = 1

        }
      }
    }
  }
}
</script>

<style lang="scss" scope>
.out-scroll-wrp {
  overflow: auto;
}

.linkDio-tit {
  width: 100%;
  text-align: center;
  height: 33px;
  font-size: 24px;
  font-weight: 600;
  color: var(--text-color);
  line-height: 33px;
  margin-bottom: 20px;
}

.subtitle {
  font-size: 24px;
  line-height: 33px;
  font-weight: 600;
  margin-bottom: 10px;
  color: var(--text-color);
}

.minititle {
  font-size: 20px;
  line-height: 25px;
  margin-bottom: 50px;
  color: var(--text-color);
}

.table-outline {
  max-height: 50vh;
  overflow-y: auto;

  .table-head {
    box-sizing: border-box;
    background: var(--background-color-3);
    opacity: 1;
    border: 1px solid #5F5F5F;
    display: table;
    margin: auto;

    .table-head-left {
      box-sizing: border-box;
      width: 260px;
      border-right: 1px solid var(--background-color-3);
      // float: left;
      display: table-cell;
      min-height: 50px;
      word-break: break-word;
    }

    .table-head-week {
      box-sizing: border-box;
      width: 134px;
      border-right: 1px solid #5F5F5F;
      // float: left;
      display: table-cell;

      h3 {
        padding: 10px 0 2px 0;
        text-align: center;
        font-size: 16px;
        font-family: PingFang SC-Semibold, PingFang SC;
        color: var(--text-color);
        line-height: 19px;
        margin: 0;
      }

      h4 {
        padding: 0 0 8px 0;
        margin: 0;
        text-align: center;
        font-size: 12px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: var(--text-color);
        line-height: 18px;
      }
    }

    div:nth-last-child(1) {
      border-right: none;
    }
  }

  .table-body-line {
    border: 1px solid #5F5F5F;
    border-top: none;
    background: var(--background-color-3);
    display: table;
    margin: auto;

    .table-line-left {
      box-sizing: border-box;
      width: 260px;
      border-right: 1px solid #5F5F5F;
      // float: left;
      display: table-cell;
      min-height: 50px;
      padding-top: 10px;
      padding-bottom: 10px;
      font-family: PingFang SC-Semibold, PingFang SC;
      color: var(--text-color);
      line-height: 36px;
      position: relative;
      word-break: break-word;
      min-height: 60px;
      cursor: pointer;

      .arw {
        width: 20px;
        height: 20px;
        position: absolute;
        top: 20px;
        right: 20px;
        mask-repeat: no-repeat !important;
        mask-position: center center!important;
        mask-size: contain!important;
        background-color: var(--text-color)!important;
        mask: url("../../../assets/chevron-right.svg");
        -webkit-mask: url("../../../assets/chevron-right.svg");
      }

      .up {
        mask: url("../../../assets/chevron-up.svg");
        -webkit-mask: url("../../../assets/chevron-up.svg");
      }
    }

    .hideArrow {
      cursor: default;

      .arw {
        display: none !important;
      }
    }

    .small {
      line-height: 20px;
      padding-left: 30px;
      font-size: 10px;
      font-family: PingFang SC-Regular, PingFang SC;
    }

    .table-line-data {
      box-sizing: border-box;
      width: 134px;
      max-width: 134px;
      border-right: 1px solid #5F5F5F;
      // float: left;
      overflow: hidden;
      display: table-cell;
      padding: 10px 5px 0 5px;
      line-height: 40px;
      font-size: 18px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: white;
      text-align: center;
      position: relative;
      min-height: 60px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-all;
      height: 60px;

      .el-input {
        height: 38px !important;
      }

      .el-input__inner {
        padding: 0 !important;
        font-size: 18px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: white;
        text-align: center;
        border: none !important;
        background: transparent !important;
      }

      span {
        display: inline-block;
        min-width: 120px;
        min-height: 27px;
      }

      > .clear-value {
        font-size: 0px;
        color: #ffffff;
        padding: 2px 10px;
        border-radius: 20px;
        background: #FF4E4E;
        position: absolute;
        top: 0px;
        right: 0px;
        line-height: normal;
        transition: 0.3s;
        opacity: 0;
        z-index: 10;
      }

      &:hover {
        > .clear-value {
        
          opacity: 1;
          font-size: 12px;
        }
      }
    }

    .not-allowed {
      cursor: not-allowed;
    }

    div:nth-last-child(1) {
      border-right: none;
    }

    .pad-lft-20 {
      padding-left: 20px;
    }

    .pad-lft-40 {
      padding-left: 40px;
    }

    .pad-rgt-40 {
      padding-right: 40px;
    }

    .pad-lft-60 {
      padding-left: 60px;
    }

    .pad-lft-80 {
      padding-left: 80px;
    }

    .font16 {
      font-size: 16px;
      text-transform: capitalize;
    }

    .font18 {
      font-size: 16px;
      text-transform: capitalize;
    }

    .green {
      color: #24D788;

      .el-input__inner {
        color: #24D788;
      }
    }

    .pink {
      color: #FF4E4E;

      .el-input__inner {
        color: #FF4E4E;
      }
    }
  }
}

.table-tree {
  min-width: 1356px;
}

.text-warn {
  font-size: 18px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: var(--text-color);
  line-height: 21px;
  padding: 15px 0 65px 0;
}

.table-btns {
  text-align: center;
  margin-bottom: 20px;

  .cancel {
    width: 280px !important;
    height: 60px !important;
    background: var(--background-color-4) !important;
    margin-right: 50px !important;
    border: 2px solid var(--secondary-color) !important;
    font-size: 26px !important;
    font-family: PingFang SC-Semibold, PingFang SC !important;
    color: var(--secondary-color) !important;
    box-shadow: none !important;
    outline: none !important;
  }

  .confirm {
    width: 280px !important;
    height: 60px !important;
    background: var(--background-color-4) !important;
    border: 2px solid #D13A90 !important;
    font-size: 26px !important;
    font-family: PingFang SC-Semibold, PingFang SC !important;
    color: #D13A90 !important;
    box-shadow: none !important;
    outline: none !important;
  }
}

.not-yet {
  text-align: center;
  padding: 50px 0;
  font-size: 12px;
  font-family: PingFang SC-Semibold, PingFang SC;
  color: var(--text-color);

  .el-icon-loading {
    font-size: 20px;
  }
}

.pad-rgt-40 {
  padding-right: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/component/treeTable.vue